import {
  InvoiceResponse,
  postInvoice,
  SuccessResponse,
} from '@back-office/http';
import { cast } from 'mobx-state-tree';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import { CreateQRForm } from '../../forms';
import { handleNotAuthorized, Self } from '../common';

export interface PostInvoiceRequest extends CreateQRForm {
  acqMerchantId: string;
}

export function* invoiceRequest(
  self: Self,
  body: PostInvoiceRequest
): Generator<Promise<FlowReturn<InvoiceResponse>>> {
  self.isLoading = true;
  try {
    const response = yield postInvoice({
      acqRequesterId: body.acqRequesterId,
      ref1: body.ref1,
      amount: body.amount,
      currency: 'PHP',
      ref2: body?.ref2 || null,
      description: body?.description || null,
      // Note - Don't know but it's can't be null
      callBackUrl: 'https://f254a4f06f70ff8ffa5e266426f460fb.m.pipedream.net',
      returnUri: 'https://f254a4f06f70ff8ffa5e266426f460fb.m.pipedream.net',
    });
    const { data, status } = (response as InvoiceResponse).data;
    if (status.code === 1000) {
      self.invoice = {
        ...self.invoice,
        ...data,
        availableSourceOfFundCodes: cast(data.availableSourceOfFundCodes),
      };
      return Promise.resolve({ data, status });
    }
    if (status.code === 9500) {
      return handleNotAuthorized(self, response as SuccessResponse);
    }
    self.alert.title = status.messages[0];
    self.alert.open = true;
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}
